import Form from '../FormComponent.vue'

export default [
    {
        path: '/form/:token',
        name: '/form/:token',
        component: Form
    }
]